const resultSectionsData = [
  [
    'xG', // title
    'xG - Očekivani broj golova', // subtitle
    'xG', // key
    ['Očekivani broj golova na utakmici', 'Prvo poluvreme', 'Drugo poluvreme'], // field names
    '. ..', // layout pattern
  ],
  [
    'Posed lopte',
    'Očekivani posed lopte na utakmici',
    'possession',
    ['Domaćin', 'Gost'],
    '..',
  ],
  [
    'Šutevi - ukupno',
    'Očekivan br. ukupno šuteva ka golu',
    'shots',
    [
      'Prvo poluvreme',
      'Kraj utakmice',
      'Ukupno šuteva domaćin',
      'Prvo poluvreme',
      'Drugo poluvreme',
      'Ukupno šuteva gost',
      'Prvo poluvreme',
      'Drugo poluvreme',
    ],
    '.. .-.. .-..',
  ],
  [
    'Šutevi - u okvir gola',
    'Očekivan br. ukupno šuteva u okvir gola',
    'shotsOnTarget',
    [
      'Prvo poluvreme',
      'Kraj utakmice',
      'Ukupno šuteva u okvir gola domaćin',
      'Prvo poluvreme',
      'Drugo poluvreme',
      'Ukupno šuteva u okvir gola gost',
      'Prvo poluvreme',
      'Drugo poluvreme',
    ],
    '.. .-.. .-..',
  ],
  [
    'Šutevi - van okvira gola',
    'Očekivan br. ukupno šuteva van okvira gola',
    'shotsOffTarget',
    [
      'Prvo poluvreme',
      'Kraj utakmice',
      'Ukupno šuteva van okvira gola domaćin',
      'Prvo poluvreme',
      'Drugo poluvreme',
      'Ukupno šuteva van okvira gola gost',
      'Prvo poluvreme',
      'Drugo poluvreme',
    ],
    '.. .-.. .-..',
  ],
  [
    'Blokirani šutevi',
    'Očekivani br. ukupno blokiranih šuteva',
    'blockedShots',
    [
      'Prvo poluvreme',
      'Kraj utakmice',
      'Ukupno blokiranih šuteva domaćin',
      'Prvo poluvreme',
      'Drugo poluvreme',
      'Ukupno blokiranih šuteva gost',
      'Prvo poluvreme',
      'Drugo poluvreme',
    ],
    '.. .-.. .-..',
  ],
  [
    'Slobodni udarci',
    'Očekivani br. ukupno slobodnih udaraca',
    'freeKicks',
    [
      'Prvo poluvreme',
      'Kraj utakmice',
      'Ukupno slobodnih udaraca domaćin',
      'Prvo poluvreme',
      'Drugo poluvreme',
      'Ukupno slobodnih udaraca gost',
      'Prvo poluvreme',
      'Drugo poluvreme',
    ],
    '.. .-.. .-..',
  ],
  [
    'Korneri',
    'Očekivani br. ukupno kornera',
    'corners',
    [
      'Prvo poluvreme',
      'Kraj utakmice',
      'Ukupno kornera domaćin',
      'Prvo poluvreme',
      'Drugo poluvreme',
      'Ukupno kornera gost',
      'Prvo poluvreme',
      'Drugo poluvreme',
    ],
    '.. .-.. .-..',
  ],
  [
    'Ofsajdi',
    'Očekivani br. ukupno ofsajda',
    'offsides',
    [
      'Prvo poluvreme',
      'Kraj utakmice',
      'Ukupno ofsajda domaćin',
      'Prvo poluvreme',
      'Drugo poluvreme',
      'Ukupno ofsajda gost',
      'Prvo poluvreme',
      'Drugo poluvreme',
    ],
    '.. .-.. .-..',
  ],
  [
    'Centaršutevi',
    'Očekivani br. ukupno centaršuteva',
    'crosses',
    [
      'Prvo poluvreme',
      'Kraj utakmice',
      'Ukupno centaršuteva domaćin',
      'Prvo poluvreme',
      'Drugo poluvreme',
      'Ukupno centaršuteva gost',
      'Prvo poluvreme',
      'Drugo poluvreme',
    ],
    '.. .-.. .-..',
  ],
  [
    'Odbrane golmana',
    'Očekivani br. ukupan odbrana golmana',
    'goalkeeperSaves',
    [
      'Prvo poluvreme',
      'Kraj utakmice',
      'Ukupno odbrana golmana domaćin',
      'Prvo poluvreme',
      'Drugo poluvreme',
      'Ukupno odbrana golmana gost',
      'Prvo poluvreme',
      'Drugo poluvreme',
    ],
    '.. .-.. .-..',
  ],
  [
    'Faulovi',
    'Očekivani br. ukupno faulova',
    'fouls',
    [
      'Prvo poluvreme',
      'Kraj utakmice',
      'Ukupno faulova domaćin',
      'Prvo poluvreme',
      'Drugo poluvreme',
      'Ukupno faulova gost',
      'Prvo poluvreme',
      'Drugo poluvreme',
    ],
    '.. .-.. .-..',
  ],
  [
    'Žuti kartoni',
    'Očekivani br. ukupnog br. žutih kartona',
    'yellowCards',
    [
      'Prvo poluvreme',
      'Kraj utakmice',
      'Ukupno žutih kartona domaćin',
      'Prvo poluvreme',
      'Drugo poluvreme',
      'Ukupno žutih kartona gost',
      'Prvo poluvreme',
      'Drugo poluvreme',
    ],
    '.. .-.. .-..',
  ],
  [
    'Ukupno dodavanja',
    'Očekivani br. ukupnog br. dodavanja',
    'passes',
    [
      'Prvo poluvreme',
      'Kraj utakmice',
      'Ukupno dodavanja domaćin',
      'Prvo poluvreme',
      'Drugo poluvreme',
      'Ukupno dodavanja gost',
      'Prvo poluvreme',
      'Drugo poluvreme',
    ],
    '.. .-.. .-..',
  ],
  [
    'Precizna dodavanja',
    'Očekivani br. ukupnih preciznih dodavanja',
    'accuratePasses',
    [
      'Prvo poluvreme',
      'Kraj utakmice',
      'Ukupno preciznih dodavanja domaćin',
      'Prvo poluvreme',
      'Drugo poluvreme',
      'Ukupno preciznih dodavanja gost',
      'Prvo poluvreme',
      'Drugo poluvreme',
    ],
    '.. .-.. .-..',
  ],
  [
    'Klizeći startovi',
    'Očekivani br. ukupnih klizećih startova',
    'tackles',
    [
      'Prvo poluvreme',
      'Kraj utakmice',
      'Ukupno klizećih startova domaćin',
      'Prvo poluvreme',
      'Drugo poluvreme',
      'Ukupno klizećih startova gost',
      'Prvo poluvreme',
      'Drugo poluvreme',
    ],
    '.. .-.. .-..',
  ],
  [
    'Napadi',
    'Očekivani broj napadačkih akcija',
    'attacks',
    [
      'Prvo poluvreme',
      'Kraj utakmice',
      'Ukupno napadačkih akcija domaćin',
      'Prvo poluvreme',
      'Drugo poluvreme',
      'Ukupno napadačkih akcija gost',
      'Prvo poluvreme',
      'Drugo poluvreme',
    ],
    '.. .-.. .-..',
  ],
  [
    'Opasni napadi',
    'Očekivani broj opasnih napada',
    'dangerousAttacks',
    [
      'Prvo poluvreme',
      'Kraj utakmice',
      'Ukupno opasnih napada domaćin',
      'Prvo poluvreme',
      'Drugo poluvreme',
      'Ukupno opasnih napada gost',
      'Prvo poluvreme',
      'Drugo poluvreme',
    ],
    '.. .-.. .-..',
  ],
  [
    'Snage timova', // title for the first block
    'Snaga domaćina',
    'teamStrength',
    ['SND ( snaga napada )', 'SOD ( snaga odbrane )'],
    '..',
  ],
  [
    undefined, // no title for the second block
    'Snaga gosta',
    'teamStrength',
    ['SNG ( snaga napada )', 'SOG ( snaga odbrane )'],
    '..',
  ],
  [
    undefined, // no title for the third block
    'Snage oba tima zajedno',
    'teamStrength',
    ['SNDG ( snaga napada )', 'SODG ( snaga odbrane )'],
    '..',
  ],
  [
    undefined, // no title for the third block
    'Tim proseci odbrana i napada',
    'teamStrength',
    [
      'SND + SOG ( dom. daje/gost prima )',
      'SOD + SNG ( dom. prima/gost daje )',
    ],
    '..',
  ],
]

export default resultSectionsData
